import { Ticket, TicketMessage } from "interface/support"
import { asDate } from "utils/date"

type AuthorGroup = {
	authorDisplayName: string
	authorType: TicketMessage["authorType"]
	messages: TicketMessage[]
}

const DURATION_MINUTES = 60

export function groupMessages(messages: TicketMessage[]) {
	const timeGroups: TicketMessage[][] = []

	for (const message of messages) {
		const lastGroup = timeGroups.at(-1)
		const reference = lastGroup?.[0]

		if (
			reference &&
			asDate(message.createdAt).diff(asDate(reference.createdAt), "minute") <=
				DURATION_MINUTES
		) {
			lastGroup.push(message)
		} else {
			timeGroups.push([message])
		}
	}

	return timeGroups.map((group) => {
		const authorGroups: AuthorGroup[] = []

		for (const message of group) {
			const lastGroup = authorGroups.at(-1)

			if (
				lastGroup &&
				lastGroup.authorDisplayName === message.authorDisplayName &&
				lastGroup.authorType === message.authorType
			) {
				lastGroup.messages.push(message)
			} else {
				authorGroups.push({
					authorDisplayName: message.authorDisplayName,
					authorType: message.authorType,
					messages: [message],
				})
			}
		}

		return { time: group[0].createdAt, authorGroups }
	})
}

export function sortTickets(ticketA: Ticket, ticketB: Ticket) {
	const statusOrder = (status: Ticket["status"]) =>
		({ NeedsFeedback: 0, Open: 1, Closed: 2, Cancelled: 3 })[status] ?? 4
	const statusDiff = statusOrder(ticketA.status) - statusOrder(ticketB.status)
	if (statusDiff !== 0) {
		return statusDiff
	}
	return asDate(ticketB.updatedAt).unix() - asDate(ticketA.updatedAt).unix()
}

export function sortTicketMessages(
	ticketMessageA: TicketMessage,
	ticketMessageB: TicketMessage,
) {
	return (
		asDate(ticketMessageA.createdAt).unix() -
		asDate(ticketMessageB.createdAt).unix()
	)
}
